module.exports = __webpack_public_path__ + "static/media/close-button.600b2dbc.svg";